import { Component } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { NgIf, NgFor } from '@angular/common';
import { AuthenticationService } from '../../services/authentication.service';
import { ApplicationService } from '../../services/application.service';
import { SessionService } from '../../services/session.service';
import { Router } from '@angular/router';
import { PERMISSIONS } from '../../models/constants';
import { Player } from '../../models/player';

@Component({
  selector: 'app-createsession',
  standalone: true,
  imports: [FormsModule, NgIf, NgFor],
  templateUrl: './createsession.component.html',
  styleUrl: './createsession.component.css'
})
export class CreatesessionComponent {

  constructor(private authenticationService:AuthenticationService, private sessionService:SessionService, private applicationService:ApplicationService, private router:Router) {
    
    this.setup();
  }

  async setup() {
    this.canManageOtherSessions = await this.authenticationService.userHasPermission(PERMISSIONS.MANAGEOTHERSESSIONS);
    this.sessionData.username = this.authenticationService.getLoggedInUsername();
    const now = new Date();
    this.sessionData.sessionDate = now.toISOString();
    this.users = await this.authenticationService.getAllPlayers();
  }

  async onSubmit(formData: NgForm) {
    this.applicationService.showGlobalSpinner();
    await this.sessionService.createSession(this.sessionData);
    this.applicationService.hideGlobalSpinner();
    this.router.navigate(['/sessions']);
  }

  resetForm(formData: NgForm) {
    this.router.navigate(['/sessions']);
  }

  users:Array<Player> = [];
  canManageOtherSessions:boolean = false;

  sessionData = {
    label: '',
    description: '',
    username: '',
    sessionDate: ''
  };
}
